[
  {
    "code": "KH-2",
    "name": "Batdâmbâng"
  },
  {
    "code": "KH-1",
    "name": "Bântéay Méanchey"
  },
  {
    "code": "KH-9",
    "name": "Kaôh Kong"
  },
  {
    "code": "KH-23",
    "name": "Krong Kêb"
  },
  {
    "code": "KH-24",
    "name": "Krong Pailin"
  },
  {
    "code": "KH-18",
    "name": "Krong Preah Sihanouk"
  },
  {
    "code": "KH-10",
    "name": "Krâchéh"
  },
  {
    "code": "KH-3",
    "name": "Kâmpóng Cham"
  },
  {
    "code": "KH-4",
    "name": "Kâmpóng Chhnang"
  },
  {
    "code": "KH-5",
    "name": "Kâmpóng Spœ"
  },
  {
    "code": "KH-6",
    "name": "Kâmpóng Thum"
  },
  {
    "code": "KH-7",
    "name": "Kâmpôt"
  },
  {
    "code": "KH-8",
    "name": "Kândal"
  },
  {
    "code": "KH-11",
    "name": "Môndól Kiri"
  },
  {
    "code": "KH-22",
    "name": "Otdâr Méanchey"
  },
  {
    "code": "KH-12",
    "name": "Phnum Pénh"
  },
  {
    "code": "KH-15",
    "name": "Pousaat"
  },
  {
    "code": "KH-13",
    "name": "Preah Vihéar"
  },
  {
    "code": "KH-14",
    "name": "Prey Vêng"
  },
  {
    "code": "KH-16",
    "name": "Rôtânôkiri"
  },
  {
    "code": "KH-17",
    "name": "Siemréab"
  },
  {
    "code": "KH-19",
    "name": "Stueng Traeng [Stœng Trêng]"
  },
  {
    "code": "KH-20",
    "name": "Svay Rieng"
  },
  {
    "code": "KH-21",
    "name": "Takêv"
  }
]